import React, { createContext, useState, useEffect, useContext } from 'react';
import { useLiff } from '../hooks/useLiff';

// 認証コンテキストの作成
const AuthContext = createContext(null);

// LIFF ID - 環境変数を使用
const LIFF_ID = import.meta.env.VITE_REACT_APP_LIFF_ID || '2007240462-YK3n6zeO';

export const AuthProvider = ({ children }) => {
  // LIFF関連の状態
  const {
    profile,
    isLoggedIn,
    login,
    logout,
    loading: liffLoading,
    error: liffError,
    isInClient,
    shareContent,
    refreshProfile
  } = useLiff(LIFF_ID);

  // 認証状態チェックが完了したかどうかのフラグ
  const [authCheckDone, setAuthCheckDone] = useState(false);

  // LIFF読み込み完了時に認証チェックを行う
  useEffect(() => {
    if (!liffLoading) {
      // 認証チェック完了をマーク
      setAuthCheckDone(true);
    }
  }, [liffLoading]);

  // userIdを安全に取得する関数
  const getUserId = () => {
    // profileからuserIdを取得
    if (profile && profile.userId) {
      return profile.userId;
    }
    
    // profileがnullの場合、ローカルストレージから取得
    try {
      const storedProfileStr = localStorage.getItem('user_profile');
      if (storedProfileStr) {
        const storedProfile = JSON.parse(storedProfileStr);
        if (storedProfile && storedProfile.userId) {
          return storedProfile.userId;
        }
      }
    } catch (error) {
      console.error('Error parsing stored profile:', error);
    }
    
    // 両方とも取得できない場合はnullを返す
    return null;
  };

  // ログイン処理 - URLパラメータを保持
  const handleLogin = (redirectAppId) => {
    if (redirectAppId) {
      const redirectUrl = `${window.location.origin}?id=${redirectAppId}`;
      login(redirectUrl);
    } else {
      login();
    }
  };

  // コンテキストに提供する値
  const authContextValue = {
    profile,
    isLoggedIn,
    login: handleLogin,
    logout,
    liffLoading,
    liffError,
    isInClient,
    shareContent,
    refreshProfile,
    authCheckDone,
    userId: getUserId()
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

// カスタムフックで認証コンテキストを利用
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
